module.exports = __webpack_public_path__ + "static/media/loader-white.434e0f21.svg";